var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrScanV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13100_20492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6663 29.666H36.333V33.9993H39.6663V29.666Z",
    fill: "#D2464F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9993 45.333H39.666V49.6663H45.9993V45.333Z",
    fill: "#D2464F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.333 38.666V42.3327H30.333V49.666H34.333V45.3327H39.6663V38.666H36.333Z",
    fill: "#D2464F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6667 29.666H46V33.9993H49.6667V29.666Z",
    fill: "#D2464F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6667 38.666H46V45.3327H49.6667V38.666Z",
    fill: "#D2464F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9993 34.333H39.666V38.6663H45.9993V34.333Z",
    fill: "#D2464F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.333 14.333V27.6663H27.6663V14.333H14.333ZM23.9997 24.333H17.6663V17.6663H23.9997V24.333Z",
    fill: "#D2464F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.333 14.333V27.6663H49.6663V14.333H36.333ZM45.9997 24.333H39.6663V17.6663H45.9997V24.333Z",
    fill: "#D2464F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.333 36V49.3333H27.6663V36H14.333ZM23.9997 46H17.6663V39.3333H23.9997V46Z",
    fill: "#D2464F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6663 29.666H14.333V33.3327H17.6663V29.666Z",
    fill: "#D2464F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.333 29.666H34.333V38.666H29.9997V33.666H25.333V29.666Z",
    fill: "#D2464F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.333 18.666H30.333V27.666H34.333V18.666Z",
    fill: "#D2464F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66634 8.66634V18.6663H5.33301V9.66634C5.33301 8.66634 5.66634 7.33301 6.66634 6.66634C7.33301 5.66634 8.66634 5.33301 9.66634 5.33301H18.6663V8.66634H8.66634Z",
    fill: "#D2464F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.333 5.33301C55.6663 5.33301 56.6663 5.66634 57.333 6.66634C58.333 7.33301 58.6663 8.66634 58.6663 9.66634V18.6663H55.333V8.66634H45.333V5.33301H54.333Z",
    fill: "#D2464F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66634 45.333V55.333H18.6663V58.6663H9.66634C8.33301 58.6663 7.33301 58.333 6.66634 57.333C5.66634 56.6663 5.33301 55.333 5.33301 54.333V45.333H8.66634Z",
    fill: "#D2464F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.333 55.333V45.333H58.6663V54.333C58.6663 55.6663 58.333 56.6663 57.333 57.333C56.6663 58.333 55.333 58.6663 54.333 58.6663H45.333V55.333H55.333Z",
    fill: "#D2464F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13100_20492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.3333,
    height: 53.3333,
    fill: "white",
    transform: "translate(5.33301 5.33301)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrScanV2);
export default __webpack_public_path__ + "static/media/qr-scan-v2.a587e5e34c70ac3b42f41140d0523a4a.svg";
export { ForwardRef as ReactComponent };